module.exports = __webpack_public_path__ + "img/99.d8bd1a62.png";